// extracted by mini-css-extract-plugin
export var slider = "Slider-module--slider--2jUnl";
export var testimonialWrapper = "Slider-module--testimonialWrapper--1p5oS";
export var sliderHeadline = "Slider-module--sliderHeadline--3Bs7W";
export var authorWrapper = "Slider-module--authorWrapper--1pBZU";
export var featureBtn = "Slider-module--featureBtn--10Fu9";
export var quote = "Slider-module--quote--3WRKw";
export var btnCircle = "Slider-module--btnCircle--Zllk6";
export var fadeIn = "Slider-module--fadeIn--2uz_i";